<template>
  <q-input
    :model-value="reportPost.comment"
    placeholder="Add External Comments Here..."
    autogrow
    borderless
    @update:modelValue="onInput"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { ReportPost } from '@/type';
import { HasTaskMixin } from '@/mixins';
import { edit } from './report-post';

interface Data {
  task: Promise<void>|null,
  delayedSave: Function,
}

export default defineComponent({
  emits: ['update:modelValue'],
  mixins: [HasTaskMixin],
  props: {
    reportPost: {
      type: Object as () => ReportPost,
      required: true,
    },
  },
  data(): Data {
    const vm = this;
    return {
      task: null,
      delayedSave: () => {}, // Overrided in created()
    };
  },
  methods: {
    onInput(comment: string) {
      // Autosize textarea emits input event when nothing changed
      if (this.reportPost.comment === comment) return;
      this.$emit('update:modelValue', comment);
      this.delayedSave();
    },
  },
  created() {
    this.delayedSave = _.debounce(() => {
      this.task = edit(this.reportPost.id, this.reportPost.comment);
    }, 1000);
  },
});
</script>
